import influencerImage from "../../assets/images/profile.jpg";
import Button from "../../components/Button";

const ScheduledInfluencer = () => {
  return (
    <div className="bg-[#f8f8f8] rounded p-5 border border-[#e0e0e0]">
      <div className="title mb-5">
        <span>Nutrition</span>
      </div>
      <div className="main-info flex">
        <div className="image w-5/12 pr-4 overflow-hidden">
          <img src={influencerImage} alt="" className="w-full" />
        </div>
        <div className="info w-7/12">
          <div className="name text-base font-semibold">
            <span>Ebru Bekiroğlu</span>
          </div>
          <div className="location text-sm text-[#828282]">
            <span>Istanbul, Turkey</span>
          </div>
          <div className="languages py-2 flex">
            <span className="bg-[#ffd2c9] text-[11px] text-[#803324] rounded font-semibold py-1 px-2 mr-1">
              Turkish
            </span>
            <span className="bg-[#ffd2c9] text-[11px] text-[#803324] rounded font-semibold py-1 px-2 mr-1">
              Turkish
            </span>
          </div>
          <div className="action">
            <Button
              isHovered
              radius="rounded-full"
              font={"text-sm text-white"}
              padding="px-5 py-2"
            >
              In-person
            </Button>
          </div>
        </div>
      </div>
      <div className="initial-assessment mt-6 flex items-center">
        <div className="main w-8/12">
          <div className="text-basejustify-between">
            <h5 className="mb-1">Initial Assessment</h5>
            <p className="text-[#8b8b8b] text-sm">
              15 minutes intial consultation, Initial dietary analysis
            </p>
          </div>
        </div>
        <div className="price flex flex-col items-end w-4/12">
          <span className="text-base text-[#e66553] font-medium">19$</span>
          <span className="text-[11px] text-[#8b8b8b]">Monthly</span>
        </div>
      </div>
    </div>
  );
};

export default ScheduledInfluencer;
